var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 461,
    height: 111,
    viewBox: "0 0 461 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_86)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.73 5.93003C56.36 -3.72997 34.1 1.52003 18.56 15.38C3.02 29.24 0.5 50.67 0.5 50.67C0.5 50.67 9.06 33.55 27.17 31.77C45.05 30.01 72.03 50.38 87.62 63.77C87.62 63.77 91.48 67.58 98.41 61.59C105.34 55.6 105.03 43.79 105.03 43.79C105.56 33.24 97.1 15.6 76.73 5.94003V5.93003Z",
    fill: "#0481BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.7898 69.34C78.0198 66.55 62.7998 54.6 57.8098 51.31C31.6898 34.05 21.9298 39.54 15.4098 43.84C7.69985 48.93 -6.17015 73.72 15.4098 93.54C36.9898 113.37 52.7898 109.99 52.7898 109.99C52.7898 109.99 18.7198 98.12 20.9198 79.22C21.8698 71.06 25.5298 64.09 42.9698 75.26C43.6698 75.7 44.3798 76.09 45.1098 76.43C45.1098 76.43 63.6798 88.51 75.6098 79.29C82.3098 73.05 79.7898 69.33 79.7898 69.33V69.34Z",
    fill: "#013957"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 50.67C0.5 50.67 8.89 34.07 25.5 32.53C42.11 30.99 60.26 43.3 60.26 43.3C60.26 43.3 7.32 2.25001 0.5 50.66V50.67Z",
    fill: "#013957"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.7896 69.34C79.7896 69.34 59.5696 47.63 36.7196 40.77C15.4496 34.39 7.58959 52.28 5.54959 58.78C3.50959 65.28 3.25959 72.76 6.05959 80.46C6.05959 80.46 14.2096 59.28 36.1596 72.52C49.5796 80.61 57.2796 84.56 68.8796 82.37C80.4796 80.18 82.5196 71.92 79.7996 69.35L79.7896 69.34Z",
    fill: "#0481BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.51 77.02V35H155.05V44.19H136.91V51.41H153.24V60.6H136.91V77.01H125.5L125.51 77.02Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.39 77.02V35H187.8V67.82H204.79V77.01H176.4L176.39 77.02Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.71 35H259.03V62.74C259.03 65.94 258.28 68.64 256.78 70.83C255.28 73.03 253.18 74.69 250.46 75.82C247.74 76.95 244.55 77.51 240.89 77.51C237.23 77.51 233.99 76.95 231.28 75.82C228.57 74.69 226.47 73.03 224.98 70.83C223.5 68.63 222.75 65.94 222.75 62.74V35H234.16V62.24C234.16 63.8 234.76 65.07 235.96 66.04C237.16 67.01 238.8 67.5 240.89 67.5C242.98 67.5 244.69 67.01 245.9 66.04C247.1 65.07 247.71 63.8 247.71 62.24V35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.099 35L290.989 47.23H291.319L298.289 35H311.009L298.449 56.01L311.499 77.02H298.449L291.309 64.55H290.979L283.839 77.02H270.869L283.749 56.01L271.279 35H284.079H284.099Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.69 35V77.02H350.17L334.99 54.95H334.74V77.02H323.33V35H333.01L347.94 56.99H348.27V35H359.68H359.69Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.68 77.02V35H406.96V44.19H388.08V51.41H405.4V60.6H388.08V67.82H406.87V77.01H376.67L376.68 77.02Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.869 44.19V35H460.389V44.19H447.749V77.02H436.509V44.19H423.869Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_86"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 460,
    height: 111,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.be2d5cd51dab9198880c12a45bb7a770.svg";
export { ForwardRef as ReactComponent };